import { formatDate, formatTime } from '../../utils/date';
import { Column } from './types';

export default {
  date(record: unknown, column: Column) {
    return formatDate(value(record, column.id));
  },

  time(record: unknown, column: Column) {
    return formatTime(value(record, column.id));
  },
};

function value(record: any, field: string) {
  if (
    record &&
    typeof record === 'object' &&
    field in record &&
    record[field]
  ) {
    return record[field];
  }

  return '';
}
